<template>
    <v-expansion-panels accordion flat v-if="menus" :ref="locale"> 
      
      <v-expansion-panel
        v-for="(menu, i) of menus"
        :key="i"
        style="background-color: tomato;border-radius:0;"
        :style="{ 'background-color': primaryBGColor,
                  'color': primaryTextColor
                }"
      >
        <iberostar-food-header :data="menu.Name" :format="data.IberostarFoodPrimaryTextFormat" />
        <v-expansion-panel-content v-if="!menu.Submenus || menu.Submenus.length === 0" :ref="locale">
          {{menu.Description}}
        </v-expansion-panel-content>
        <v-expansion-panel-content v-else>
     <v-expansion-panels accordion flat>
      <v-expansion-panel
        v-for="(submenu, i) of menu.Submenus"
        :key="i"
        style="border-radius: 0;"
        :style="{ 'background-color': secondaryBGColor,
                  'color': secondaryTextColor
                }"
      >
      <iberostar-food-header :data="submenu.Name" :hideArrow="!submenu.Dishes" :format="data.IberostarFoodSecondaryTextFormat" />
        <v-expansion-panel-content v-if="submenu.Dishes" style="background-color:white;padding: 5px 0px">
          <food-drink
            v-for="item of submenu.Dishes"
            :key="item.ID"
            :data="item"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
</template>

 <script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import constants from '@/constants'
  import IberostarFoodHeader from './IberostarFoodHeader'
  import FoodDrink from '../foodDrink/Index'
  import _ from 'lodash'
  export default {
    components: {
      FoodDrink,
      IberostarFoodHeader,
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
    },
    data: () => ({
      loading: true,
      response: null,
      menus: null,
      primaryBGColor: null,
      primaryTextColor: null,
      secondaryBGColor: null,
      secondaryTextColor: null,
    }),
    computed:{
      ...mapState('app',['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      BGColor () {
        return this.$store.state.app.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
    },
    watch: {
      'data.IberostarFoodRestaurant' () {
        this.getIberostarFood()
      },
      'data.IberostarFoodPrimaryBGColor' (v) {
        this.primaryBGColor = v
      },
      'data.IberostarFoodPrimaryTextColor' (v) {
        this.primaryTextColor = v
      },
      'data.IberostarFoodSecondaryBGColor' (v) {
        this.secondaryBGColor = v
      },
      'data.IberostarFoodSecondaryTextColor' (v) {
        this.secondaryTextColor = v
      },
      'locale' () {
        this.prepareData()
      }
    },
    created () {
      this.handleLoadComplete = _.debounce(() => {
        this.loading = false
      }, 500)
    },
    mounted() {
      this.primaryBGColor = this.data.IberostarFoodPrimaryBGColor
      this.primaryTextColor = this.data.IberostarFoodPrimaryTextColor
      this.secondaryBGColor = this.data.IberostarFoodSecondaryBGColor
      this.secondaryTextColor = this.data.IberostarFoodSecondaryTextColor
      this.getIberostarFood()
    },
    methods: {
      getIberostarFood(){
        if (this.data.IberostarFoodRestaurant && this.data.IberostarFoodRestaurant !== undefined) {
          api.getAll(`enterprises/iberostar/${this.enterpriseID ? this.enterpriseID : utils.getDomain()}`, false, 1, 10000, '', `${this.data.IberostarFoodRestaurant}`).then(response => {
            console.log('response',response)
              this.response = response
              this.prepareData()
          })
        
            /*
          const url = `https://iberostar.dviewcontent.com/public/menus/ebeebdaf-9dc0-442f-a97b-514a3cb08c95/${this.data.IberostarFoodRestaurant}`
          axios.get(url)
            .then((response) => {
              this.response = response.data
              this.prepareData()
            })
            */
        }
      },
      htmlEntities(str) {
        return String(str).split('&ntilde;').join('ñ')
                        .split('&Ntilde;').join('Ñ')
                        .split('&amp;').join('&')
                        .split('&Ntilde;').join('Ñ')
                        .split('&ntilde;').join('ñ')
                        .split('&Ntilde;').join('Ñ')
                        .split('&Agrave;').join('À')
                        .split('&Aacute;').join('Á')  
                        .split('&Acirc;').join('Â')
                        .split('&Atilde;').join('Ã')   
                        .split('&Auml;').join('Ä')
                        .split('&Aring;').join('Å')
                        .split('&AElig;').join('Æ')
                        .split('&Ccedil;').join('Ç')
                        .split('&Egrave;').join('È')
                        .split('&Eacute;').join('É')
                        .split('&Ecirc;').join('Ê')
                        .split('&Euml;').join('Ë')
                        .split('&Igrave;').join('Ì')
                        .split('&Iacute;').join('Í')
                        .split('&Icirc;').join('Î')
                        .split('&Iuml;').join('Ï')
                        .split('&ETH;').join('Ð')
                        .split('&Ntilde;').join('Ñ')
                        .split('&Ograve;').join('Ò')
                        .split('&Oacute;').join('Ó')
                        .split('&Ocirc;').join('Ô')
                        .split('&Otilde;').join('Õ')
                        .split('&Ouml;').join('Ö')
                        .split('&Oslash;').join('Ø')
                        .split('&Ugrave;').join('Ù')
                        .split('&Uacute;').join('Ú')
                        .split('&Ucirc;').join('Û')
                        .split('&Uuml;').join('Ü')
                        .split('&Yacute;').join('Ý')
                        .split('&THORN;').join('Þ')
                        .split('&szlig;').join('ß')
                        .split('&agrave;').join('à')
                        .split('&aacute;').join('á')
                        .split('&acirc;').join('â')
                        .split('&atilde;').join('ã')
                        .split('&auml;').join('ä')
                        .split('&aring;').join('å')
                        .split('&aelig;').join('æ')
                        .split('&ccedil;').join('ç')
                        .split('&egrave;').join('è')
                        .split('&eacute;').join('é')
                        .split('&ecirc;').join('ê')
                        .split('&euml;').join('ë')
                        .split('&igrave;').join('ì')
                        .split('&iacute;').join('í')
                        .split('&icirc;').join('î')
                        .split('&iuml;').join('ï')
                        .split('&eth;').join('ð')
                        .split('&ntilde;').join('ñ')
                        .split('&ograve;').join('ò')
                        .split('&oacute;').join('ó')
                        .split('&ocirc;').join('ô')
                        .split('&otilde;').join('õ')
                        .split('&ouml;').join('ö')
                        .split('&oslash;').join('ø')
                        .split('&ugrave;').join('ù')
                        .split('&uacute;').join('ú')
                        .split('&ucirc;').join('û')
                        .split('&uuml;').join('ü')   
                        .split('&yacute;').join('ý')  
                        .split('&thorn;').join('þ')
                        .split('&yuml;').join('ÿ')
                        .split('&nbsp;').join(' ')
                        .split('&rsquo;').join("'")
                        .replace(/(<([^>]+)>)/gi, '')
      },
      prepareJSON (v) {
        return typeof v === 'object' ? v : JSON.parse(v)
      },
      prepareSubmenu(parentID) {
        return this.response.filter(x => x.ParentID === parentID).map(item => {
          item.Name = item.Name ? this.prepareJSON(item.Name) : ''
          //item.Description = item.Description ? utils.getTranslation(JSON.parse(item.Description), this.locale) : ''
          item.Description = item.Description ? item.Description : ''
          item.Submenus = this.prepareSubmenu(item.ID)
          item.Dishes = item.Dishes ? item.Dishes.map(dishe => {
            dishe.FoodName = dishe.Name ? this.prepareJSON(dishe.Name) : null
            dishe.FoodPrice = dishe.Price ? `${dishe.Price}${dishe.Currency === 'EUR' ? '€' : diche.Currency}` : null
            dishe.FoodIngredients = dishe.Description ? this.prepareJSON(this.htmlEntities(dishe.Description)) : null
            return dishe
          }) : null
          return item
        })
      },
      prepareData() {
        this.menus = this.response.filter(x => !x.ParentID).map(item => {
          item.Name = item.Name ? this.prepareJSON(item.Name) : ''
          //item.Description = item.Description ? utils.getTranslation(this.prepareJSON(item.Description), this.locale) : ''
          item.Description = item.Description ? item.Description : ''
          item.Submenus = this.prepareSubmenu(item.ID)
          return item
        })
      }
    }
  }
</script>
<style>
  iframe {
    overflow-x:hidden;
    overflow-y:hidden;
    overflow:hidden;
  }
</style>
